"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.default = void 0;
var _changeDetails = _interopRequireDefault(require("../core/change-details.js"));
var _holder = _interopRequireDefault(require("../core/holder.js"));
var _utils = require("../core/utils.js");
var _base = _interopRequireDefault(require("./base.js"));
var _factory = _interopRequireWildcard(require("./factory.js"));
var _chunkTailDetails = _interopRequireDefault(require("./pattern/chunk-tail-details.js"));
var _cursor = _interopRequireDefault(require("./pattern/cursor.js"));
var _fixedDefinition = _interopRequireDefault(require("./pattern/fixed-definition.js"));
var _inputDefinition = _interopRequireDefault(require("./pattern/input-definition.js"));
require("./regexp.js");
require("../core/continuous-tail-details.js");
var _excluded = ["expose", "repeat"],
  _excluded2 = ["_blocks"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropSet(t, e, o, r, p, f) { return _set(_getPrototypeOf(f ? t.prototype : t), e, o, r, p); }
function set(e, r, t, o) { return set = "undefined" != typeof Reflect && Reflect.set ? Reflect.set : function (e, r, t, o) { var f, i = _superPropBase(e, r); if (i) { if ((f = Object.getOwnPropertyDescriptor(i, r)).set) return f.set.call(o, t), !0; if (!f.writable) return !1; } if (f = Object.getOwnPropertyDescriptor(o, r)) { if (!f.writable) return !1; f.value = t, Object.defineProperty(o, r, f); } else _defineProperty(o, r, t); return !0; }, set(e, r, t, o); }
function _set(e, r, t, o, f) { if (!set(e, r, t, o || e) && f) throw new TypeError("failed to set property"); return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/** Pattern mask */
var MaskedPattern = exports.default = /*#__PURE__*/function (_Masked) {
  /** */

  /** */

  /** Single char for empty input */

  /** Single char for filled input */

  /** Show placeholder only when needed */

  /** Enable characters overwriting */

  /** */

  /** */

  /** */

  function MaskedPattern(opts) {
    _classCallCheck(this, MaskedPattern);
    return _callSuper(this, MaskedPattern, [_objectSpread(_objectSpread(_objectSpread({}, MaskedPattern.DEFAULTS), opts), {}, {
      definitions: Object.assign({}, _inputDefinition.default.DEFAULT_DEFINITIONS, opts == null ? void 0 : opts.definitions)
    })]);
  }
  _inherits(MaskedPattern, _Masked);
  return _createClass(MaskedPattern, [{
    key: "updateOptions",
    value: function updateOptions(opts) {
      _superPropGet(MaskedPattern, "updateOptions", this, 3)([opts]);
    }
  }, {
    key: "_update",
    value: function _update(opts) {
      opts.definitions = Object.assign({}, this.definitions, opts.definitions);
      _superPropGet(MaskedPattern, "_update", this, 3)([opts]);
      this._rebuildMask();
    }
  }, {
    key: "_rebuildMask",
    value: function _rebuildMask() {
      var _this = this;
      var defs = this.definitions;
      this._blocks = [];
      this.exposeBlock = undefined;
      this._stops = [];
      this._maskedBlocks = {};
      var pattern = this.mask;
      if (!pattern || !defs) return;
      var unmaskingBlock = false;
      var optionalBlock = false;
      var _loop = function _loop(_i) {
          if (_this.blocks) {
            var p = pattern.slice(_i);
            var bNames = Object.keys(_this.blocks).filter(function (bName) {
              return p.indexOf(bName) === 0;
            });
            // order by key length
            bNames.sort(function (a, b) {
              return b.length - a.length;
            });
            // use block name with max length
            var bName = bNames[0];
            if (bName) {
              var _normalizeOpts = (0, _factory.normalizeOpts)(_this.blocks[bName]),
                expose = _normalizeOpts.expose,
                repeat = _normalizeOpts.repeat,
                bOpts = _objectWithoutProperties(_normalizeOpts, _excluded); // TODO type Opts<Arg & Extra>
              var blockOpts = _objectSpread(_objectSpread({
                lazy: _this.lazy,
                eager: _this.eager,
                placeholderChar: _this.placeholderChar,
                displayChar: _this.displayChar,
                overwrite: _this.overwrite,
                autofix: _this.autofix
              }, bOpts), {}, {
                repeat: repeat,
                parent: _this
              });
              var maskedBlock = repeat != null ? new _holder.default.RepeatBlock(blockOpts /* TODO */) : (0, _factory.default)(blockOpts);
              if (maskedBlock) {
                _this._blocks.push(maskedBlock);
                if (expose) _this.exposeBlock = maskedBlock;

                // store block index
                if (!_this._maskedBlocks[bName]) _this._maskedBlocks[bName] = [];
                _this._maskedBlocks[bName].push(_this._blocks.length - 1);
              }
              _i += bName.length - 1;
              i = _i;
              return 0; // continue
            }
          }
          var char = pattern[_i];
          var isInput = char in defs;
          if (char === MaskedPattern.STOP_CHAR) {
            _this._stops.push(_this._blocks.length);
            i = _i;
            return 0; // continue
          }
          if (char === '{' || char === '}') {
            unmaskingBlock = !unmaskingBlock;
            i = _i;
            return 0; // continue
          }
          if (char === '[' || char === ']') {
            optionalBlock = !optionalBlock;
            i = _i;
            return 0; // continue
          }
          if (char === MaskedPattern.ESCAPE_CHAR) {
            ++_i;
            char = pattern[_i];
            if (!char) {
              i = _i;
              return 1;
            } // break
            isInput = false;
          }
          var def = isInput ? new _inputDefinition.default(_objectSpread(_objectSpread({
            isOptional: optionalBlock,
            lazy: _this.lazy,
            eager: _this.eager,
            placeholderChar: _this.placeholderChar,
            displayChar: _this.displayChar
          }, (0, _factory.normalizeOpts)(defs[char])), {}, {
            parent: _this
          })) : new _fixedDefinition.default({
            char: char,
            eager: _this.eager,
            isUnmasking: unmaskingBlock
          });
          _this._blocks.push(def);
          i = _i;
        },
        _ret;
      for (var i = 0; i < pattern.length; ++i) {
        _ret = _loop(i);
        if (_ret === 0) continue;
        if (_ret === 1) break;
      }
    }
  }, {
    key: "state",
    get: function get() {
      return _objectSpread(_objectSpread({}, _superPropGet(MaskedPattern, "state", this, 1)), {}, {
        _blocks: this._blocks.map(function (b) {
          return b.state;
        })
      });
    },
    set: function set(state) {
      if (!state) {
        this.reset();
        return;
      }
      var _blocks = state._blocks,
        maskedState = _objectWithoutProperties(state, _excluded2);
      this._blocks.forEach(function (b, bi) {
        return b.state = _blocks[bi];
      });
      _superPropSet(MaskedPattern, "state", maskedState, this, 1, 1);
    }
  }, {
    key: "reset",
    value: function reset() {
      _superPropGet(MaskedPattern, "reset", this, 3)([]);
      this._blocks.forEach(function (b) {
        return b.reset();
      });
    }
  }, {
    key: "isComplete",
    get: function get() {
      return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every(function (b) {
        return b.isComplete;
      });
    }
  }, {
    key: "isFilled",
    get: function get() {
      return this._blocks.every(function (b) {
        return b.isFilled;
      });
    }
  }, {
    key: "isFixed",
    get: function get() {
      return this._blocks.every(function (b) {
        return b.isFixed;
      });
    }
  }, {
    key: "isOptional",
    get: function get() {
      return this._blocks.every(function (b) {
        return b.isOptional;
      });
    }
  }, {
    key: "doCommit",
    value: function doCommit() {
      this._blocks.forEach(function (b) {
        return b.doCommit();
      });
      _superPropGet(MaskedPattern, "doCommit", this, 3)([]);
    }
  }, {
    key: "unmaskedValue",
    get: function get() {
      return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce(function (str, b) {
        return str += b.unmaskedValue;
      }, '');
    },
    set: function set(unmaskedValue) {
      if (this.exposeBlock) {
        var tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
        this.exposeBlock.unmaskedValue = unmaskedValue;
        this.appendTail(tail);
        this.doCommit();
      } else _superPropSet(MaskedPattern, "unmaskedValue", unmaskedValue, this, 1, 1);
    }
  }, {
    key: "value",
    get: function get() {
      return this.exposeBlock ? this.exposeBlock.value :
      // TODO return _value when not in change?
      this._blocks.reduce(function (str, b) {
        return str += b.value;
      }, '');
    },
    set: function set(value) {
      if (this.exposeBlock) {
        var tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
        this.exposeBlock.value = value;
        this.appendTail(tail);
        this.doCommit();
      } else _superPropSet(MaskedPattern, "value", value, this, 1, 1);
    }
  }, {
    key: "typedValue",
    get: function get() {
      return this.exposeBlock ? this.exposeBlock.typedValue : _superPropGet(MaskedPattern, "typedValue", this, 1);
    },
    set: function set(value) {
      if (this.exposeBlock) {
        var tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
        this.exposeBlock.typedValue = value;
        this.appendTail(tail);
        this.doCommit();
      } else _superPropSet(MaskedPattern, "typedValue", value, this, 1, 1);
    }
  }, {
    key: "displayValue",
    get: function get() {
      return this._blocks.reduce(function (str, b) {
        return str += b.displayValue;
      }, '');
    }
  }, {
    key: "appendTail",
    value: function appendTail(tail) {
      return _superPropGet(MaskedPattern, "appendTail", this, 3)([tail]).aggregate(this._appendPlaceholder());
    }
  }, {
    key: "_appendEager",
    value: function _appendEager() {
      var _this$_mapPosToBlock;
      var details = new _changeDetails.default();
      var startBlockIndex = (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : _this$_mapPosToBlock.index;
      if (startBlockIndex == null) return details;

      // TODO test if it works for nested pattern masks
      if (this._blocks[startBlockIndex].isFilled) ++startBlockIndex;
      for (var bi = startBlockIndex; bi < this._blocks.length; ++bi) {
        var d = this._blocks[bi]._appendEager();
        if (!d.inserted) break;
        details.aggregate(d);
      }
      return details;
    }
  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch, flags) {
      if (flags === void 0) {
        flags = {};
      }
      var blockIter = this._mapPosToBlock(this.displayValue.length);
      var details = new _changeDetails.default();
      if (!blockIter) return details;
      for (var bi = blockIter.index, block; block = this._blocks[bi]; ++bi) {
        var _flags$_beforeTailSta;
        var blockDetails = block._appendChar(ch, _objectSpread(_objectSpread({}, flags), {}, {
          _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) == null || (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null ? void 0 : _flags$_beforeTailSta[bi]
        }));
        details.aggregate(blockDetails);
        if (blockDetails.consumed) break; // go next char
      }
      return details;
    }
  }, {
    key: "extractTail",
    value: function extractTail(fromPos, toPos) {
      var _this2 = this;
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      var chunkTail = new _chunkTailDetails.default();
      if (fromPos === toPos) return chunkTail;
      this._forEachBlocksInRange(fromPos, toPos, function (b, bi, bFromPos, bToPos) {
        var blockChunk = b.extractTail(bFromPos, bToPos);
        blockChunk.stop = _this2._findStopBefore(bi);
        blockChunk.from = _this2._blockStartPos(bi);
        if (blockChunk instanceof _chunkTailDetails.default) blockChunk.blockIndex = bi;
        chunkTail.extend(blockChunk);
      });
      return chunkTail;
    }
  }, {
    key: "extractInput",
    value: function extractInput(fromPos, toPos, flags) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      if (flags === void 0) {
        flags = {};
      }
      if (fromPos === toPos) return '';
      var input = '';
      this._forEachBlocksInRange(fromPos, toPos, function (b, _, fromPos, toPos) {
        input += b.extractInput(fromPos, toPos, flags);
      });
      return input;
    }
  }, {
    key: "_findStopBefore",
    value: function _findStopBefore(blockIndex) {
      var stopBefore;
      for (var si = 0; si < this._stops.length; ++si) {
        var stop = this._stops[si];
        if (stop <= blockIndex) stopBefore = stop;else break;
      }
      return stopBefore;
    }

    /** Appends placeholder depending on laziness */
  }, {
    key: "_appendPlaceholder",
    value: function _appendPlaceholder(toBlockIndex) {
      var details = new _changeDetails.default();
      if (this.lazy && toBlockIndex == null) return details;
      var startBlockIter = this._mapPosToBlock(this.displayValue.length);
      if (!startBlockIter) return details;
      var startBlockIndex = startBlockIter.index;
      var endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;
      this._blocks.slice(startBlockIndex, endBlockIndex).forEach(function (b) {
        if (!b.lazy || toBlockIndex != null) {
          var _blocks2;
          details.aggregate(b._appendPlaceholder((_blocks2 = b._blocks) == null ? void 0 : _blocks2.length));
        }
      });
      return details;
    }

    /** Finds block in pos */
  }, {
    key: "_mapPosToBlock",
    value: function _mapPosToBlock(pos) {
      var accVal = '';
      for (var bi = 0; bi < this._blocks.length; ++bi) {
        var block = this._blocks[bi];
        var blockStartPos = accVal.length;
        accVal += block.displayValue;
        if (pos <= accVal.length) {
          return {
            index: bi,
            offset: pos - blockStartPos
          };
        }
      }
    }
  }, {
    key: "_blockStartPos",
    value: function _blockStartPos(blockIndex) {
      return this._blocks.slice(0, blockIndex).reduce(function (pos, b) {
        return pos += b.displayValue.length;
      }, 0);
    }
  }, {
    key: "_forEachBlocksInRange",
    value: function _forEachBlocksInRange(fromPos, toPos, fn) {
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      var fromBlockIter = this._mapPosToBlock(fromPos);
      if (fromBlockIter) {
        var toBlockIter = this._mapPosToBlock(toPos);
        // process first block
        var isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
        var fromBlockStartPos = fromBlockIter.offset;
        var fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].displayValue.length;
        fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);
        if (toBlockIter && !isSameBlock) {
          // process intermediate blocks
          for (var bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi) {
            fn(this._blocks[bi], bi, 0, this._blocks[bi].displayValue.length);
          }

          // process last block
          fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
        }
      }
    }
  }, {
    key: "remove",
    value: function remove(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      var removeDetails = _superPropGet(MaskedPattern, "remove", this, 3)([fromPos, toPos]);
      this._forEachBlocksInRange(fromPos, toPos, function (b, _, bFromPos, bToPos) {
        removeDetails.aggregate(b.remove(bFromPos, bToPos));
      });
      return removeDetails;
    }
  }, {
    key: "nearestInputPos",
    value: function nearestInputPos(cursorPos, direction) {
      if (direction === void 0) {
        direction = _utils.DIRECTION.NONE;
      }
      if (!this._blocks.length) return 0;
      var cursor = new _cursor.default(this, cursorPos);
      if (direction === _utils.DIRECTION.NONE) {
        // -------------------------------------------------
        // NONE should only go out from fixed to the right!
        // -------------------------------------------------
        if (cursor.pushRightBeforeInput()) return cursor.pos;
        cursor.popState();
        if (cursor.pushLeftBeforeInput()) return cursor.pos;
        return this.displayValue.length;
      }

      // FORCE is only about a|* otherwise is 0
      if (direction === _utils.DIRECTION.LEFT || direction === _utils.DIRECTION.FORCE_LEFT) {
        // try to break fast when *|a
        if (direction === _utils.DIRECTION.LEFT) {
          cursor.pushRightBeforeFilled();
          if (cursor.ok && cursor.pos === cursorPos) return cursorPos;
          cursor.popState();
        }

        // forward flow
        cursor.pushLeftBeforeInput();
        cursor.pushLeftBeforeRequired();
        cursor.pushLeftBeforeFilled();

        // backward flow
        if (direction === _utils.DIRECTION.LEFT) {
          cursor.pushRightBeforeInput();
          cursor.pushRightBeforeRequired();
          if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
          cursor.popState();
          if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
          cursor.popState();
        }
        if (cursor.ok) return cursor.pos;
        if (direction === _utils.DIRECTION.FORCE_LEFT) return 0;
        cursor.popState();
        if (cursor.ok) return cursor.pos;
        cursor.popState();
        if (cursor.ok) return cursor.pos;
        return 0;
      }
      if (direction === _utils.DIRECTION.RIGHT || direction === _utils.DIRECTION.FORCE_RIGHT) {
        // forward flow
        cursor.pushRightBeforeInput();
        cursor.pushRightBeforeRequired();
        if (cursor.pushRightBeforeFilled()) return cursor.pos;
        if (direction === _utils.DIRECTION.FORCE_RIGHT) return this.displayValue.length;

        // backward flow
        cursor.popState();
        if (cursor.ok) return cursor.pos;
        cursor.popState();
        if (cursor.ok) return cursor.pos;
        return this.nearestInputPos(cursorPos, _utils.DIRECTION.LEFT);
      }
      return cursorPos;
    }
  }, {
    key: "totalInputPositions",
    value: function totalInputPositions(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      var total = 0;
      this._forEachBlocksInRange(fromPos, toPos, function (b, _, bFromPos, bToPos) {
        total += b.totalInputPositions(bFromPos, bToPos);
      });
      return total;
    }

    /** Get block by name */
  }, {
    key: "maskedBlock",
    value: function maskedBlock(name) {
      return this.maskedBlocks(name)[0];
    }

    /** Get all blocks by name */
  }, {
    key: "maskedBlocks",
    value: function maskedBlocks(name) {
      var _this3 = this;
      var indices = this._maskedBlocks[name];
      if (!indices) return [];
      return indices.map(function (gi) {
        return _this3._blocks[gi];
      });
    }
  }, {
    key: "pad",
    value: function pad(flags) {
      var details = new _changeDetails.default();
      this._forEachBlocksInRange(0, this.displayValue.length, function (b) {
        return details.aggregate(b.pad(flags));
      });
      return details;
    }
  }]);
}(_base.default);
MaskedPattern.DEFAULTS = _objectSpread(_objectSpread({}, _base.default.DEFAULTS), {}, {
  lazy: true,
  placeholderChar: '_'
});
MaskedPattern.STOP_CHAR = '`';
MaskedPattern.ESCAPE_CHAR = '\\';
MaskedPattern.InputDefinition = _inputDefinition.default;
MaskedPattern.FixedDefinition = _fixedDefinition.default;
_holder.default.MaskedPattern = MaskedPattern;